import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-auth-navbar',
  templateUrl: './auth-navbar.component.html',
  styleUrls: ['./auth-navbar.component.scss']
})
export class AuthNavbarComponent implements OnInit {
  constructor(public auth:AuthService, public common : CommonService, public router :Router) { }

  ngOnInit(): void {

  }

  goBack(){
    let curr_url = window.location.href
    //console.log(window.history)
    let sub = curr_url.split('//')[1]
    let url = sub.substr(curr_url.split('//')[1].match('/').index)
    // if(window.history.length!=0){
    window.history.back()

    setTimeout(()=>{
      if(curr_url == window.location.href){
        this.router.navigateByUrl('/')
      }
    },200)
    // }
    // else{
    //     this.router.navigateByUrl('/dashboard')  
    // }
      
  }
}
